import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTotalWeight', bringozTotalWeight);

function bringozTotalWeight(splitService, $filter) {
  return function bringozTotalWeightFilter(items, enableUnitDisplay, defaultValue) {
    const siteUnit = splitService.getWeightUnit();
    const weightUnit = $filter('translate')(siteUnit);

    const totalWeight = _.reduce(items, (sum, i) => {
      return sum + _.get(i, 'weight', 0);
    }, 0);

    if (!totalWeight) {
      return defaultValue || '--'
    }
    return totalWeight + (enableUnitDisplay ? (' ' + weightUnit) : '');
  }
}
